import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HeartOff } from 'lucide-react';
import { toast } from 'sonner';
import CourseCard from '../components/CourseCard';
import { shopAPI } from '../lib/api';
import { t } from '../lib/i18n';
import MyLearningShell from '../components/MyLearningShell';
import { EmptyState } from '../components/ui';

export default function Wishlist() {
  const [courses, setCourses] = useState(null);

  const load = useCallback(() => {
    shopAPI.wishlist().then(({ data }) => setCourses(data.courses)).catch(() => setCourses([]));
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  const remove = async (cid) => {
    try {
      await shopAPI.wishlistToggle(cid);
      load();
    } catch {
      toast.error(t('Save failed'));
    }
  };

  if (!courses) return <MyLearningShell><p className="text-sm text-lms-muted">{t('Loading…')}</p></MyLearningShell>;

  return (
    <MyLearningShell>
      {courses.length === 0 ? (
        <EmptyState>
          {t('Nothing saved yet.')}{' '}
          <Link to="/courses" className="text-lms-accent">{t('Browse courses')}</Link>
        </EmptyState>
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3">
          {courses.map((c) => (
            <div key={c.id} className="relative">
              <CourseCard course={c} />
              <button
                onClick={() => remove(c.id)}
                className="lms-press absolute right-[66px] top-[26px] z-10 flex h-8 w-8 items-center justify-center rounded-lg bg-lms-chip-bg text-lms-chip-ink shadow-[var(--lms-elev-1)] hover:text-[var(--lms-danger)]"
                title={t('Remove from wishlist')}
                aria-label={t('Remove from wishlist')}
              >
                <HeartOff size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </MyLearningShell>
  );
}
